import styled from '@emotion/styled';
var LoadingSpinner = styled.span(function (props) {
    if (!props.spin)
        return '';
    return "\n    display: flex;\n    animation: spin 1s linear infinite;\n  \n    @keyframes spin {\n      from {\n        transform: rotate(0deg);\n      }\n      to {\n        transform: rotate(360deg);\n      }\n    }\n  ";
});
export default LoadingSpinner;
